<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Primary text:</div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="80"
            [type]="'content'"
            [blockData]="block.variables?.['PrimaryText'] ?? ''"
            (handleOnChange)="onChange($event, 'PrimaryText')"
            [placeholder]="primaryTextPlaceholder"
            variable="PrimaryText"
            [isPlainText]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
      </div>
    </div>
  </div>
</main>
